import { useQuery } from "react-query";

import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";
import { IFunderInvestmentDetails } from "../interfaces/funderInvestment";

/** `Enums.SortOrder.Descending` — newest transaction first. */
const NEWEST_FIRST = 2;

/**
 * One investment with its transactions, from
 * `GET /account/get_funder_investment_by_id`.
 *
 * The lists no longer carry interest, maturity or wallet fields, so anything
 * that shows or acts on a single investment fetches it here by id rather than
 * trusting the row it was opened from.
 *
 * A pending investment is not on core banking yet and the backend answers it
 * with a 500, which surfaces as `error`.
 */
const getFunderInvestment = async (
  id: number,
): Promise<IFunderInvestmentDetails> => {
  const response = await getDataWithDotNet(
    `${ajaxEndpoints.FUNDER_INVESTMENT_BY_ID}?funderInvestmentId=${id}&sortOrder=${NEWEST_FIRST}`,
  );

  return response?.data;
};

export default function useFunderInvestment(id?: number | string | null) {
  const investmentId = Number(id);

  return useQuery<IFunderInvestmentDetails>(
    [investmentId, "getFunderInvestment"],
    () => getFunderInvestment(investmentId),
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: Number.isFinite(investmentId) && investmentId > 0,
    },
  );
}
